import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperMissionOutstandingPage } from './shopper-mission-outstanding';

@NgModule({
  declarations: [
    ShopperMissionOutstandingPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperMissionOutstandingPage),
    TranslateModule.forChild()
  ],
})
export class ShopperMissionOutstandingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-mission-outstanding/shopper-mission-outstanding.module.ts